export default __webpack_public_path__ + "static/roadmap@2x-878a7eb9de101edc1172d37c8f73dfe9.png";